import CONTRATO_TEMAS from '@/graphql/querys/administracion/contratos/contrato/temas/contratoTemas.gql';
import AGREGAR_CONTRATO_TEMA from '@/graphql/mutations/administracion/contratos/contrato/temas/agregarContratoTema.gql';
import ACTUALIZAR_CONTRATO_TEMA from '@/graphql/mutations/administracion/contratos/contrato/temas/actualizarContratoTema.gql';
import REMOVER_CONTRATO_TEMA from '@/graphql/mutations/administracion/contratos/contrato/temas/removerContratoTema.gql';

export default {
  methods: {
    // Agregar Tema
    async mixAgergarTema() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_TEMA,
          variables: {
            tema: this.tema,
          },
          update: (store, { data: { agregarContratoTema } }) => {
            const query = {
              query: CONTRATO_TEMAS,
              variables: {
                idContrato: this.idContrato,
              },
            };
            const { contratoTemas } = store.readQuery(query);
            const contratoTemasCopia = contratoTemas.slice();
            contratoTemasCopia.push(agregarContratoTema);
            store.writeQuery({
              ...query,
              data: {
                contratoTemas: contratoTemasCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Actualizar Tema
    async mixActualizarTema() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CONTRATO_TEMA,
          variables: {
            id: this.contratoTemaEditar.id,
            tema: this.tema,
          },
          update: (store, { data: { actualizarContratoTema } }) => {
            const query = {
              query: CONTRATO_TEMAS,
              variables: {
                idContrato: this.contratoTemaEditar.idContrato,
              },
            };
            const data = store.readQuery(query);
            const { contratoTemas } = data;
            const index = contratoTemas
              .findIndex((contratoTema) => contratoTema.id
              === actualizarContratoTema.id);
            if (index !== -1) {
              contratoTemas.splice(index, 1, actualizarContratoTema);
            }
            store.writeQuery({ ...query, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Eliminar Tema
    async mixEliminarTema() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CONTRATO_TEMA,
        variables: {
          id: this.contratoTemaEliminar.id,
        },
        update: (store) => {
          const query = {
            query: CONTRATO_TEMAS,
            variables: {
              idContrato: this.contratoTemaEliminar.idContrato,
            },
          };
          const data = store.readQuery(query);
          const { contratoTemas } = data;
          const index = contratoTemas
            .findIndex((tema) => tema.id === this.contratoTemaEliminar.id);
          if (index !== -1) {
            contratoTemas.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
